/* Rhode · Selector de tonos: maneja el selector original del tema y pinta el botón */
(function () {
  if (window.__rhodeShadePicker) return;
  window.__rhodeShadePicker = true;

  function driveTheme(root, value) {
    var scope = root.parentElement || document;
    var picker = scope.querySelector('.main-product-variant-selector') ||
      document.querySelector('#shopify-section-' + root.dataset.section + ' .main-product-variant-selector');
    if (!picker) return;
    var idx = parseInt(root.dataset.optionIndex, 10) - 1;
    var fieldset = picker.querySelectorAll('fieldset.product-variant--picker')[idx];
    if (!fieldset) return;
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        if (!radios[i].checked) radios[i].click();
        return;
      }
    }
    var select = fieldset.querySelector('select');
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function paintButton(root, color, ink) {
    ['add-to-cart-', 'sticky-add-to-cart-'].forEach(function (prefix) {
      var btn = document.getElementById(prefix + root.dataset.section);
      if (!btn) return;
      if (color) {
        btn.style.setProperty('--rsp-btn', color);
        btn.style.setProperty('--rsp-ink', ink || '#FFFFFF');
      } else {
        btn.style.removeProperty('--rsp-btn');
        btn.style.removeProperty('--rsp-ink');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-rsp][data-mode="variants"] .rsp-sw');
    if (!sw) return;
    e.preventDefault();
    var root = sw.closest('[data-rsp]');
    document.querySelectorAll('[data-rsp][data-mode="variants"][data-section="' + root.dataset.section + '"] .rsp-sw').forEach(function (b) {
      var on = b.dataset.value === sw.dataset.value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var name = root.querySelector('[data-rsp-name]');
    if (name) name.textContent = (sw.dataset.value || '').toLowerCase();
    var desc = root.querySelector('[data-rsp-desc]');
    if (desc) {
      desc.textContent = sw.dataset.desc ? '- ' + sw.dataset.desc : '';
      desc.hidden = !sw.dataset.desc;
    }
    paintButton(root, sw.dataset.color, sw.dataset.ink);
    driveTheme(root, sw.dataset.value);
  });

  /* ===== Vista rápida: los tonos que son productos separados (modo familia)
     no llevan a la ficha. El tono tocado queda marcado al instante y la vista
     rápida se recarga con ese producto (foto, precio y botón de agregar), sin
     salir de la página. ===== */
  var qvStyle = document.createElement('style');
  qvStyle.textContent = '#quickView-drawer.qv-swapping .quick-view-details{opacity:.55;pointer-events:none;transition:opacity .2s ease}';
  document.head.appendChild(qvStyle);
  var qvCache = {};
  function qvFetch(url) {
    var key = url.split('#')[0].split('?')[0];
    if (!qvCache[key]) {
      qvCache[key] = fetch(key, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('#quickView-drawer');
          if (!el) throw new Error('sin vista rápida');
          return el.innerHTML;
        })
        .catch(function (err) { delete qvCache[key]; throw err; });
    }
    return qvCache[key];
  }
  function qvBindClose(drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        drawer.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden');
      });
    });
  }
  function qvSwap(link) {
    var drawer = link.closest('#quickView-drawer');
    if (!drawer || drawer.classList.contains('qv-swapping')) return;
    var root = link.closest('[data-rsp]');
    if (root) {
      root.querySelectorAll('.rsp-sw').forEach(function (b) {
        var on = b === link;
        b.classList.toggle('is-selected', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      var nm = root.querySelector('.rsp-name');
      var label = link.getAttribute('title') || link.getAttribute('aria-label');
      if (nm && label) nm.textContent = label.replace(/\s*\(agotado\)$/, '').toLowerCase();
    }
    var dd = link.closest('[data-rsp-dd]');
    if (dd) dd.removeAttribute('open');
    drawer.classList.add('qv-swapping');
    var form = drawer.querySelector('.modal-dialog-form');
    var scroll = form ? form.scrollTop : 0;
    qvFetch(link.href).then(function (inner) {
      drawer.innerHTML = inner;
      drawer.classList.add('is-visible');
      document.body.classList.add('overflow-hidden');
      qvBindClose(drawer);
      var nf = drawer.querySelector('.modal-dialog-form');
      if (nf) nf.scrollTop = scroll;
      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      if (typeof trapFocusElements === 'function') trapFocusElements(drawer);
    }).catch(function () {
      window.location.href = link.href;
    }).then(function () {
      drawer.classList.remove('qv-swapping');
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('#quickView-drawer [data-rsp][data-mode="family"] a.rsp-sw, #quickView-drawer [data-rsp][data-mode="family"] a.rsp-dd-item');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (link.classList.contains('is-selected')) return;
    qvSwap(link);
  });
  /* Precarga al pasar el mouse o apoyar el dedo: el cambio es casi instantáneo */
  ['pointerenter', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('#quickView-drawer [data-rsp][data-mode="family"] a.rsp-sw');
      if (link && !link.classList.contains('is-selected')) qvFetch(link.href).catch(function () {});
    }, { capture: true, passive: true });
  });

  /* Dropdown del tono: se cierra al tocar afuera o con Escape */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-rsp-dd][open]').forEach(function (dd) {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-rsp-dd][open]').forEach(function (dd) { dd.removeAttribute('open'); });
  });
})();
